import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { Role } from './role.enum';
import { UserService } from '../user/user.service';

type MatchMode = 'all' | 'any';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const userService = inject(UserService);
  const router = inject(Router);

  const required: Role[] = route.data['required'] ?? [];
  const match: MatchMode = route.data['match'] ?? 'all';

  if (!required.length) {
    return true;
  }

  const roles = userService.currentUser().roles;
  const isAuthorized = match === 'all'
    ? required.every((role) => roles.includes(role))
    : required.some((role) => roles.includes(role));

  // TODO(Security): Restore the role decision below before production release.
  // return isAuthorized ? true : router.parseUrl('/forbidden');
  return true;
};
